export const dataTableDefaults = {
  data() {
    return {
      dataTableFooterProps: {
        'items-per-page-text': 'Filas por página:',
        'items-per-page-all-text': 'Todos',
        'page-text': '{0}-{1} de {2}',
      },
      tableProps: {
        'no-data-text': 'No hay datos disponibles',
        'no-results-text': 'No se encontraron registros',
        'loading-text': 'Cargando... Porfavor espere'
      },
    };
  }
};